import React from "react";
import styles from "../../styles/HomePage.module.css";

export default function HowItWorksSection() {
    return (
        <section id="how-it-works" className={styles.howItWorks}>
            <h2 className={styles.sectionTitle}>Your Path to Playing By Ear</h2>
            <div className={styles.steps}>
                <div className={styles.step}>
                    <div className={styles.stepNumber}>1</div>
                    <h3 className={styles.stepTitle}>Pick Your Skill Level</h3>
                    <p className={styles.stepDescription}>
                        Start with basic intervals or jump to advanced progressions. Choose what
                        you want to work on and set your own pace.
                    </p>
                </div>
                <div className={styles.stepArrow}>→</div>
                <div className={styles.step}>
                    <div className={styles.stepNumber}>2</div>
                    <h3 className={styles.stepTitle}>Train Your Ears Daily</h3>
                    <p className={styles.stepDescription}>
                        Listen to musical examples and identify what you hear. Real sounds from
                        real instruments - just like figuring out songs in the real world.
                    </p>
                </div>
                <div className={styles.stepArrow}>→</div>
                <div className={styles.step}>
                    <div className={styles.stepNumber}>3</div>
                    <h3 className={styles.stepTitle}>Apply It to Real Music</h3>
                    <p className={styles.stepDescription}>
                        Take your trained ear to your instrument or voice. Start recognizing
                        melodies, chords, and progressions in the songs you love.
                    </p>
                </div>
            </div>
        </section>
    );
}
